import script from "./ArticlePreviewMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePreviewMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePreviewMolecule.vue?vue&type=style&index=0&id=53b94014&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b94014"]])

export default __exports__